import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../../../../commons/services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';

@Component({
    selector: 'app-plus-mouvement',
    templateUrl: './plus-mouvement.component.html',
    styleUrls: ['./plus-mouvement.component.css'],
    standalone: false
})
export class PlusMouvementComponent implements OnInit {
  @Input() listMouvSupp;
  @Input() isShowSite;
  @Input() article;
  @Input() newprest;
  @Input() groupId;

  mouvementSupplementaire;
  selectedRow: any = {};
  isEdit: Boolean = false;
  listeSite = [];
  listeSiteCA = [];
  defaultSite: any = {};

  dataDepot = [];
  dataRetrait = [];
  dataRotation = [];
  dataAutre = [];
  dataOppSupp = [];
  dataOppSuppBennePlace = [];
  defaultSelectedOPeration = {};
  operationBenneEnPlaceFalse = false;

  societe: any = {};

  hasRetrait: Boolean = false;
  isMvtRetrait: Boolean = false;


  defaultSelectedOPerationDefauf: any = {};
  defaultSelectedDefaut: any = {};
  dataisOpSurBenneEnPlace = [];

  listOperationNew = [
    { id: 0, libelleObjetEntite: 'Depot' },
  ];
  listOperationBenne = [
    { id: 2, libelleObjetEntite: 'Rotation' },
    { id: 1, libelleObjetEntite: 'Retrait' },
  ];
  defaultSelected;

  listExutoire = [];

  @ViewChild('msg') msg;
  @Output() hidefunction = new EventEmitter<any>();
  @Output() validefunction = new EventEmitter<any>();
  @Output() saveFerier = new EventEmitter<any>();
  @Output() saveSusp = new EventEmitter<any>();
  constructor(public common: CommonService, private modalService: BsModalService) { }

  ngOnInit() {
    this.societe = this.common.local.getObject('paramSociete') || {};
    this.listMouvSupp = this.listMouvSupp || [];
    this.article = this.article || {};
    this.mouvementSupplementaire = [];
    this.listMouvSupp.forEach(elt => {
      this.mouvementSupplementaire.push(Object.assign({}, elt));
    });
    const listeSite = this.common.local.getObject('listeSite') || [];
    this.listeSite = listeSite || [];
    this.listeSite.forEach(elt => {
      if (elt.id === this.common.user[2]) {
        this.defaultSite = elt;
      }
    });
    const list = this.common.getType('listOperationSupp') || [];
    list.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    const list2 = this.common.getType('listOperationSuppBennePlace') || [];

    list2.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    this.dataisOpSurBenneEnPlace = [...list2]
    if (this.societe['operationBenneSupp']) {
      this.listOperationNew.push(...list);
      this.listOperationBenne.push(...list2);
    } else {
      this.listOperationNew.push(...[{ id: 6, libelleObjetEntite: 'Autres' }]);
      // this.listOperationBenne.push(...[{ id: 6, libelleObjetEntite: 'Autres' }]);
    }
  }

  showFormEdit(row, edit?) {
    this.hasRetrait = false;
    this.selectedRow = Object.assign({}, row);
    if (edit) {
      this.selectedRow.add = false;
      console.log(this.selectedRow);
      this.selectedRow['dateStart'] = this.common.parseDate(this.selectedRow['dateaffiche']);
      this.isMvtRetrait = parseInt(this.selectedRow['operation'], 10) === 1 ? true : false;
      this.selectedRow['hourDuree'] = Math.floor(parseFloat(this.selectedRow['duree']));
      this.selectedRow['minDuree'] = Math.round((parseFloat(this.selectedRow['duree']) - parseInt(this.selectedRow['hourDuree'], 10)) * 60);
      this.selectedRow['hourDuree'] = this.selectedRow['hourDuree'] === 0 ? '00' : this.selectedRow['hourDuree'];
      this.selectedRow['minDuree'] = this.selectedRow['minDuree'] === 0 ? '00' : this.selectedRow['minDuree'];
      this.selectedRow['isImportant'] = this.selectedRow['important'];
      this.getOperationMvt();
    } else {
      this.selectedRow.id = (this.mouvementSupplementaire.length + 1);
      this.selectedRow['sitePrest'] = Object.assign({}, this.defaultSite)
      this.selectedRow.add = true;
      this.selectedRow['hourDuree'] = '00';
      this.selectedRow['minDuree'] = '00';
      const operationArticle = this.article.opBenne || {};
      const premiereOperation = operationArticle.isOperationSupp ?
        (operationArticle.operationSurBenneEnPlace ? '2' : '0') : '2';
      this.selectedRow['operation'] = premiereOperation;
      this.getOperationMvt();
    }

    this.mouvementSupplementaire.forEach(mvtPgm => {
      if (!this.hasRetrait) {
        this.hasRetrait = parseInt((mvtPgm.operation || 0), 10) === 1 ? true : false;
      }
    });

    this.dataDepot = this.getListOperation(0);
    this.dataRetrait = this.getListOperation(1);
    this.dataRotation = this.getListOperation(2);
    this.dataAutre = this.getListOperation(6);
    this.dataOppSupp = this.getListOperation('listOperationSupp');
    this.dataOppSuppBennePlace = this.getListOperation('listOperationSuppBennePlace');
    this.isEdit = true;
  }

  close() {
    this.hidefunction.emit();
  }

  save() {
    this.newprest['listMouvSupp'] = [];
    this.mouvementSupplementaire.forEach(elt => {
      this.newprest['listMouvSupp'].push(Object.assign({}, elt));
    });
    console.log(this.newprest['listMouvSupp'])
    this.close();
  }

  saveMouv() {
    if (this.selectedRow.add) {
      const list = [this.createObjMvt()]
      this.mouvementSupplementaire = [...this.mouvementSupplementaire, ...list]
    } else {
      this.mouvementSupplementaire.forEach(element => {
        if (element.id === this.selectedRow.id) {
          element = this.createObjMvt();
        }
      });
    }

    console.log( this.mouvementSupplementaire);
    this.isEdit = false;
  }

  delete(row) {
    this.mouvementSupplementaire = this.mouvementSupplementaire.filter(elt => elt.id !== row.id);
  }

  createObjMvt() {
    /***Modif à faire demain */
    const duree = this.parseDureeMvt();
    const sitePrest = this.isShowSite ? (this.selectedRow['sitePrest'] ? this.selectedRow['sitePrest'].id
      : this.common.user[2]) : this.common.user[2];
    const mouvement = {
      'dateDemande': moment().format('YYYY-MM-DD'),
      'dateEnlevement': moment(this.selectedRow['dateStart']).format('DD/MM/YYYY'),
      'dateaffiche': moment(this.selectedRow['dateStart']).format('DD/MM/YYYY'),
      'heure': this.selectedRow['heure'],
      // 'clefBenneChantiers': '' + (this.benneChantier['id'] || 0),
      'clefClient': '' + (this.newprest['client'] ? this.newprest['client'].id : '0'),
      'operation': '' + (this.selectedRow['typeOperation'] ? this.selectedRow['typeOperation'].id : '0'), // choix operation
      'operationAffiche': '' + (this.selectedRow['typeOperation'] ? this.selectedRow['typeOperation'].libelleObjetEntite : ''),
      'clefExutoire': '' + (this.selectedRow['exutoire'] ? (this.selectedRow['exutoire'].id || '0') : '0'),
      'exutoire': this.selectedRow['exutoire'],
      'siteExploitation': {
        id: '' + (sitePrest || ('' + this.common.user[2]))
      },
      'sitePrest': this.selectedRow['sitePrest'],
      'clefSiteCA': '' + this.common.user[2],
      'infoSup': (this.selectedRow['infoNextMouv'] || ''),
      'infoNextMouv': (this.selectedRow['infoNextMouv'] || ''),
      'user': '' + this.common.user[0],
      'important': this.selectedRow['isImportant'],
      'duree': duree,
      'auPlusTard': (this.newprest['auPlusTard'] || false),
      'nomclass': 'Mouvement'
    };


    return mouvement;
  }

  parseDureeMvt() {
    const heureDuree = parseInt((this.selectedRow['hourDuree'] || 0), 10);
    const minDuree = parseFloat('' + parseInt((this.selectedRow['minDuree'] || 0), 10) / 60).toFixed(2);
    const duree = heureDuree + parseFloat(minDuree);
    console.log('duree = ' + duree);
    return duree;
  }

  searchSite(event) {
    this.listeSiteCA = [];
    this.listeSite.forEach(elt => {
      elt.libelleObjetEntite = elt.nom;
      this.listeSiteCA.push(elt);
    });
  }

  getOperationMvt() {
    const operation = [];
    const list = this.common.getType('listOperationSupp') || [];
    list.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    const list2 = this.common.getType('listOperationSuppBennePlace') || [];
    let existe = false;
    list2.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    operation.push(...this.listOperationBenne, ...this.listOperationNew);
    operation.forEach(elt => {
      if (elt.id === parseInt(this.selectedRow['operation'], 10)) {
        existe = true;
        this.selectedRow['typeOperation'] = elt;
        this.defaultSelected = elt;
        this.defaultSelectedOPeration = Object.assign({}, elt);
        if (!elt.operationSurBenneEnPlace && (elt.id !== 2 && elt.id !== 1)) {
          this.operationBenneEnPlaceFalse = true;
        } else {
          this.operationBenneEnPlaceFalse = false;
        }
      }
    });


    console.log('this.operationBenneEnPlaceFalse', this.operationBenneEnPlaceFalse, this.defaultSelectedOPeration)

    if ((this.defaultSelectedOPeration && !this.defaultSelectedOPeration['id']) || !existe) {
      const operationSupp = [...list, ...list2];
      operationSupp.forEach(elt => {
        if (elt.id === parseInt(this.selectedRow['operation'], 10)) {
          existe = true;
          this.selectedRow['typeOperation'] = elt;
          this.defaultSelected = elt;
          this.defaultSelectedOPeration = Object.assign({}, elt);
        }
      });
    }
  }

  isBenneEnPlace(operaion) {
    const list = this.common.getType('listOperationSuppBennePlace') || [];
    const existe = list.filter(elt => operaion && elt.id === operaion.id);
    return existe && existe.length ? true : false;
  }

  isBenneNonEnPlace(operaion) {
    const list = this.common.getType('listOperationSupp') || [];
    const existe = list.filter(elt => operaion && elt.id === operaion.id);
    return existe && existe.length ? true : false;
  }

  getListOperation(type) {
    let value = [];
    const dataOperation = this.societe['operationBenneSupp'] ? [
      { id: 0, libelle: 'Dépot' },
      { id: 1, libelle: 'Retrait' },
      { id: 2, libelle: 'Rotation' }
    ] : [
      { id: 0, libelle: 'Dépot' },
      { id: 1, libelle: 'Retrait' },
      { id: 2, libelle: 'Rotation' },
      // { id: 6, libelle: 'Autres' }
    ];

    if (!this.societe['operationBenneSupp'] && (type === 0 || type === 6 || type === 'listOperationSupp')) {
      dataOperation.push({ id: 6, libelle: 'Autres' })
    }

    const listOperationSuppBennePlace = this.societe['operationBenneSupp'] ? this.common.getType('listOperationSuppBennePlace') : [];
    const listOperationSupp = this.societe['operationBenneSupp'] ? this.common.getType('listOperationSupp') : [];
    switch (type) {
      case 0:
        value = dataOperation.filter(elt => elt.id !== 1 && elt.id !== 2);
        value = [...value, ...this.societe['operationBenneSupp'] ? listOperationSupp : []];
        break;
      case 1:
        value = dataOperation.filter(elt => elt.id !== 0 && elt.id !== 6);
        if (this.societe['operationBenneSupp']) {
          value = [...value, ...listOperationSuppBennePlace];
        }
        break;
      case 2:
        value = dataOperation.filter(elt => elt.id !== 0 && elt.id !== 6);
        if (this.societe['operationBenneSupp']) {
          value = [...value, ...listOperationSuppBennePlace];
        }

        if (this.hasRetrait && !this.isMvtRetrait) {
          value = value.filter(elt => elt.id !== 1);
        }
        break;
      case 6:
        value = dataOperation.filter(elt => elt.id !== 2);
        if (this.societe['operationBenneSupp']) {
          value = [...value, ...listOperationSuppBennePlace];
        }
        if (this.hasRetrait && !this.isMvtRetrait) {
          value = value.filter(elt => elt.id !== 1);
        }
        break;
      case 'listOperationSupp':
        if (this.societe['operationBenneSupp']) {
          value = dataOperation.filter(elt => elt.id !== 1 && elt.id !== 2 && elt.id !== 6);
        } else {
          value = dataOperation.filter(elt => elt.id !== 1 && elt.id !== 2);
        }

        value = [...value, ...listOperationSupp];
        break;
      case 'listOperationSuppBennePlace':
        if (this.societe['operationBenneSupp']) {
          value = dataOperation.filter(elt => elt.id !== 0 && elt.id !== 6);
        } else {
          value = dataOperation.filter(elt => elt.id !== 0 && elt.id !== 6);
        }
        value = [...value, ...listOperationSuppBennePlace];
        if (this.hasRetrait && !this.isMvtRetrait) {
          value = value.filter(elt => elt.id !== 1);
        }
        break;
    }

    value.forEach(elt => elt.libelleObjetEntite = elt.libelle || '');
    return value;
  }

  changeDateStart(event) {
    const ctrl = this;
    if (typeof event === 'string' && event.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)) {
      ctrl.selectedRow['dateStart'] = ctrl.common.parseDate(event);
    }
  }

  selectDate(event, id) {
    this.common.focusElement(id);
  }

  searchExutoire(event) {
    const idart = !this.newprest['newContenant'] ? (this.newprest['contenant'] ? (this.newprest['contenant'].art ?
      this.newprest['contenant'].art.id : 0) : 0) : (this.newprest['newBenne'] ? (this.newprest['newBenne'].art ?
        this.newprest['newBenne'].art.id : 0) : 0);
    const param = {
      'servlet': 'DBGetListeExuLimites',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_CHANTIER': {
          'typeParam': 'int',
          'valeur': this.newprest['chantier'] ? this.newprest['chantier'].id : 0
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.newprest['client'] ? this.newprest['client'].id : 0
        },
        'LIST_ARTICLES': this.groupId.length ? this.groupId : ['' + idart],
        'CRITERE_NOM_EXUTOIRE': event + '%'
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        if (datas.data && datas.data.length) {
          datas.data.forEach(elt => elt.libelleObjetEntite = elt.nom || elt.libelleObjetEntite);
          this.listExutoire = datas.data;
        } else {
          this.anotheExutoire(event);
        }
      }
    });
  }

  anotheExutoire(event) {
    const param = 6;

    return this.common.appelComboK3Fct( param, event ).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listExutoire = datas.data;
      }
    });
  }

}
